import type { AnchorHTMLAttributes } from 'react';

export const title = 'Вход на\u00A0видео-встречу';
export const subtitle = 'Представьтесь, чтобы участникам было удобнее с\u00A0вами общаться';
export const buttonText = 'Присоединиться';
export const inputPlaceholder = 'Иванов Иван';

export const agreementContent = (() => {
    const linkProps: AnchorHTMLAttributes<HTMLAnchorElement> = {
        rel: 'noreferrer',
        target: '_blank',
    };

    return (
        <span>
            Принимаю условия{' '}
            <a href='https://trendrealty.ru/polzovatelskoe-soglashenie' {...linkProps}>
                пользовательского соглашения
            </a>
            , соглашаюсь с{' '}
            <a href='https://trendrealty.ru/politika-konfidencialnosti' {...linkProps}>
                политикой конфиденциальности
            </a>{' '}
            и{' '}
            <a href='https://trendrealty.ru/politika-fajlov-cookies' {...linkProps}>
                политикой Cookie
            </a>
        </span>
    );
})();
